// Retailer configuration
export const RETAILER_LOGOS = {
  "Amazon": "/images/retailers/AmazonLogo.png",
  "Scheels": "/images/retailers/ScheelsLogo.png",
  "Bass Pro": "/images/retailers/bass-pro-logo.svg",
  "Cabela's": "/images/retailers/CabelasLogo.png",
  "FishUSA": "/images/retailers/FishUSALogo.png",
  "Sportsman's Warehouse": "/images/retailers/SportsmansWarehouseLogo.png",
  "Sportsman's Guide": "/images/retailers/SportsmansGuideLogo.png",
  "Amped Outdoors": "https://ampedoutdoors.com/cdn/shop/files/Amped_Outdoors_LITHIUM_b31b579c-5858-4e86-bae1-14df90eef9e1.png",
  "HD Innovations": "/images/retailers/HDInnovations.png",
  "Summit Fishing Equipment": "/images/retailers/SummitFishing.png",
  "West Marine": "/images/retailers/West_Marine_logo_logotype.webp"
}; 